import React from 'react'
import { useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'

import {withTitle} from '@/router/utils'
import {OutletListFilterContainer, OutletsContainer} from '@/components'

export const OnlineOutletsStoreSymbol = Symbol('OnlineOutletsStoreSymbol')
export const OnlineOutletsPaginationStoreSymbol = Symbol('OnlineOutletsPaginationStoreSymbol')
export const OnlineOutletListFilterStoreSymbol = Symbol('OnlineOutletListFilterStoreSymbol')
export const OnlineOutletsStatusStoreSymbol = Symbol('OnlineOutletsStatusStoreSymbol')

const OnlineOutlets: React.FC<null> = observer(() => {
    const { t } = useTranslation()
    return (
        <OutletsContainer
            injectableIdentifier={OnlineOutletsStoreSymbol}
            paginationInjectableIdentifier={OnlineOutletsPaginationStoreSymbol}
            containerTitle={t('OnlineOutlets.onlineOutlets')}
            extra={
                <OutletListFilterContainer
                    injectableIdentifier={OnlineOutletListFilterStoreSymbol}
                />
            }
        />
    )
})

export default withTitle(OnlineOutlets, 'OnlineOutlets.onlineOutlets')
